import './ComplianceCommentModal.scss';
import { Unsubscribe } from 'redux';
import { validate } from './ComplianceCommentModal.Validation';
import actions from '../../../../store/actions';
import ComplianceComment from '../../../../types/common/ComplianceComment';
import ComplianceCommentModalState from './ComplianceCommentModalState';
import httpClient from '../../../../infrastructure/helpers/common/httpClient';
import Modal from '../../Modal/Modal';
import PromiseButton from '../../PromiseButton';
import React from 'react';
import store from '../../../../store/store';
import CustomIcon from '../../BootstrapIcons/Custom/CustomIcon';
import { ReactComponent as RemoveIcon } from '../../../Common/BootstrapIcons/close.svg';
import { ReactComponent as EditIcon } from '../../../Common/BootstrapIcons/edit.svg';
import iconTooltip from '../../../Common/BootstrapIcons/Tooltip/IconTooltip';
import copyArray from '../../../../infrastructure/helpers/common/copyArray';
import copyObject from '../../../../infrastructure/helpers/common/copyObject';

class ComplianceCommentModal extends React.Component<any, ComplianceCommentModalState> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: any) {
        super(props);

        this.state = {
            title: 'Compliance Comments',
            isOpen: false,
            comments: [],
            selectedComment: {} as ComplianceComment,
            url: '',
            error: null,
            isReadOnly: props.isReadOnly,
        };

        this.openListener = this.openListener.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onSaveSuccess = this.onSaveSuccess.bind(this);
        this.close = this.close.bind(this);
        this.getItem = this.getItem.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.openListener);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }
    openListener(): void {
        let state = store.getState();

        if (!(state.action === actions.complianceCommentModal.open ||
            state.action === actions.complianceCommentModal.deleteCommentSuccess ||
            state.action === actions.complianceCommentModal.editCommentSuccess)) {
            return;
        }

        state.complianceCommentModalState.selectedComment = undefined;

        this.setState(state.complianceCommentModalState);
    }

    onCommentChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {

        let selectedComment = {} as ComplianceComment;

        if (this.state.selectedComment) {

            selectedComment = copyObject(this.state.selectedComment as ComplianceComment);
        }

        selectedComment.content = e.target.value;

        this.setState({ selectedComment });
    }

    onSaveClick(): Promise<any> {

        let error = validate(this.state.selectedComment?.content as string);

        this.setState({ error: error });

        if (error) {
            return Promise.reject(error);
        }

        if (this.state.selectedComment?.commentId) {
            return httpClient.put(`${this.state.url}`, this.state.selectedComment).then(() => this.onEditSuccess(this.state.selectedComment as ComplianceComment));
        }

        return httpClient.post(this.state.url, { comment: this.state.selectedComment?.content }).then(this.onSaveSuccess);
    }

    onSaveSuccess(): void {

        this.setState({ isOpen: false });

        store.dispatch({ type: actions.complianceCommentModal.saveSuccess, payload: null as any });
    }

    close(): void {
        this.setState({ isOpen: false });
    }

    async onRemoveClick(comment: ComplianceComment): Promise<void> {

        await httpClient.delete(`${this.state.url}/${comment.commentId}`).then(() => this.onRemoveSuccess(comment.commentId));

        this.setState({ isOpen: false });

        store.dispatch({ type: actions.complianceCommentModal.saveSuccess, payload: null as any });
    }

    onEditClick(comment: ComplianceComment): any {

        this.setState({ selectedComment: comment });
    }

    onRemoveSuccess(commentId: number): void {
        let temp = { ...this.state };
        temp.comments = temp.comments.filter(c => c.commentId !== commentId);

        this.setState({ comments: temp.comments });

        store.dispatch({ type: actions.complianceCommentModal.deleteCommentSuccess, payload: temp });
    }

    onEditSuccess(comment: ComplianceComment): void {
        let comments = copyArray(this.state.comments);

        (comments.find(c => c.commentId === comment.commentId) as ComplianceComment).content = comment.content;

        let state = { comments, selectedComment: undefined, isOpen: false };

        this.setState(state);

        store.dispatch({ type: actions.complianceCommentModal.saveSuccess, payload: state });
    }

    getItem(comment: ComplianceComment, i: number): JSX.Element {

        return (
            <li key={i}>
                <div className="container">
                    <div className="left">
                        <div>{comment.content}</div>
                        <span>{comment.createdTimestamp} - {comment.createdBy}</span>
                    </div>
                    <div className="right">
                        <button
                            className="custom-icon-button"
                            onClick={() => this.onEditClick(comment)}>
                            <CustomIcon icon={EditIcon} title={iconTooltip.remove} />
                        </button>
                        <button
                            className="custom-icon-button"
                            onClick={() => this.onRemoveClick(comment)}>
                            <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                        </button>
                    </div>
                </div>
            </li>
        );
    }

    render(): JSX.Element {
        return (
            <Modal state={this.state} close={this.close} size="extra-large">

                <div className="compliance-comment-modal">
                    <ul>
                        {this.state.comments.map(this.getItem)}
                    </ul>

                    <textarea placeholder="Add Comment" onChange={this.onCommentChange} value={this.state.selectedComment?.content || ''} disabled={this.props.isReadOnly}></textarea>

                    <PromiseButton disabled={this.props.isReadOnly} text="Save" className="btn cb-btn" enableOnErrorOnly={false} task={this.onSaveClick} />
                </div>
            </Modal>
        );
    }
}

export default ComplianceCommentModal;
